import _slicedToArray from "/home/jenkins/jenkins_home/workspace/Efficience-dev/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/home/jenkins/jenkins_home/workspace/Efficience-dev/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/home/jenkins/jenkins_home/workspace/Efficience-dev/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import { dmpconnectConfigurationActionConstants, dmpconnectInitActionConstants as dmpconnectUserActionConstants, mssReceiptNotificationTypes } from '../constants';
import { mssSubTypes } from "../actions/config/commands";
var initialState = {
  mssLoginType: null,
  mssReceiptNotificationType: mssReceiptNotificationTypes.MDN,
  mssApiType: mssSubTypes.IMAP,
  mssImapServer: '',
  mssImapPort: '',
  mssSmtpServer: '',
  mssSmtpPort: '',
  mssImapLogin: '',
  mssImapPasswd: '',
  mssImapSaslLogin: '',
  mssSmtpLogin: '',
  mssSmtpPasswd: '',
  mssSmtpSaslLogin: '',
  mssPscAccessToken: undefined,
  mssOperatorsConfig: undefined,
  mssPatientInfosRequestsEnabled: false,
  mssOperator: undefined
};
var applyMssConfig = function applyMssConfig(state, action) {
  var newState = _objectSpread({}, state);
  // si l'operateur n'est plus le même on vide les login/mdp imap et smtp
  if (action.key === 'mssOperator') {
    if (state.mssOperator !== action.value) {
      newState = _objectSpread({}, newState, {
        mssImapLogin: initialState.mssImapLogin,
        mssImapPasswd: initialState.mssImapPasswd,
        mssImapSaslLogin: initialState.mssImapSaslLogin,
        mssSmtpLogin: initialState.mssSmtpLogin,
        mssSmtpPasswd: initialState.mssSmtpPasswd,
        mssSmtpSaslLogin: initialState.mssSmtpSaslLogin
      });
    }
  }
  return _objectSpread({}, newState, _defineProperty({}, action.key, action.value));
};
var restMssConfigFromEnv = function restMssConfigFromEnv(state, actionPayload) {
  var newState = _objectSpread({}, state);
  Object.entries(actionPayload).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    newState = applyMssConfig(newState, {
      key: key,
      value: value
    });
  });
  return newState;
};
export function dmpconnectMSSConfiguration() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case dmpconnectConfigurationActionConstants.DMPC_RESET_MSS_CONFIGURATION_FROM_ENV:
      return restMssConfigFromEnv(state, action.payload);
    case dmpconnectConfigurationActionConstants.DMPC_SET_MSS_CONFIGURATION:
      return applyMssConfig(state, action);
    case dmpconnectUserActionConstants.DMPC_LOGOUT_SUCCESS:
      return _objectSpread({}, state, {
        mssPscAccessToken: undefined
      });
    default:
      return state;
  }
}
export default function getDmpconnectMSSConfigReducer(_ref3) {
  var mssLoginType = _ref3.mssLoginType,
    mssReceiptNotificationType = _ref3.mssReceiptNotificationType,
    mssApiType = _ref3.mssApiType,
    mssImapServer = _ref3.mssImapServer,
    mssImapPort = _ref3.mssImapPort,
    mssSmtpServer = _ref3.mssSmtpServer,
    mssSmtpPort = _ref3.mssSmtpPort,
    mssImapLogin = _ref3.mssImapLogin,
    mssImapPasswd = _ref3.mssImapPasswd,
    mssImapSaslLogin = _ref3.mssImapSaslLogin,
    mssSmtpLogin = _ref3.mssSmtpLogin,
    mssSmtpPasswd = _ref3.mssSmtpPasswd,
    mssSmtpSaslLogin = _ref3.mssSmtpSaslLogin,
    mssOperatorsConfig = _ref3.mssOperatorsConfig,
    mssOperator = _ref3.mssOperator,
    mssPatientInfosRequestsEnabled = _ref3.mssPatientInfosRequestsEnabled;
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      mssLoginType: mssLoginType,
      mssReceiptNotificationType: mssReceiptNotificationType,
      mssApiType: mssApiType,
      mssImapServer: mssImapServer,
      mssImapPort: mssImapPort,
      mssSmtpServer: mssSmtpServer,
      mssSmtpPort: mssSmtpPort,
      mssImapLogin: mssImapLogin,
      mssImapPasswd: mssImapPasswd,
      mssImapSaslLogin: mssImapSaslLogin,
      mssSmtpLogin: mssSmtpLogin,
      mssSmtpPasswd: mssSmtpPasswd,
      mssSmtpSaslLogin: mssSmtpSaslLogin,
      mssOperatorsConfig: mssOperatorsConfig,
      mssOperator: mssOperator,
      mssPatientInfosRequestsEnabled: mssPatientInfosRequestsEnabled
    };
    var action = arguments.length > 1 ? arguments[1] : undefined;
    return dmpconnectMSSConfiguration(state, action);
  };
}